import { HeaderState } from "../components/Header/HeaderUtils";
import { setHeaderState, setIsAuthenticated, setIsPatientsEnabled } from "../store/reducer";

import { NavigateFunction } from "react-router-dom";
import { Dispatch } from "redux";

export function createFetchWithAuth(navigate: NavigateFunction, dispatch: Dispatch<any>) {
	// Guardamos el fetch original
	const originalFetch = window.fetch.bind(window);

	return async function (input: RequestInfo | URL, init?: RequestInit) {
		const response = await originalFetch(input, init);

		if (response.status === 401) {
			// Significa que el token expiró o es un usuario no autorizado
			console.warn("Token expirado");

			// Limpiamos la información
			dispatch(setIsAuthenticated(false));
			dispatch(setIsPatientsEnabled(false));
			dispatch(setHeaderState(HeaderState.Normal));
			localStorage.removeItem("isAuthenticatedNurasign");

			navigate("/");

			return Promise.reject(new Error("Unauthorized"));
		}

		return response;
	};
}
